import { ShadowTheme } from '@kite-js/theme-types';

export const shadow: ShadowTheme = {
    NONE: 'none',
    S: '0 3px 5px 0 rgba(0, 0, 0, 0.2)',
    M: '0 6px 8px 0 rgba(0, 0, 0, 0.3)',
    L: '0 6px 8px 0 rgba(0, 0, 0, 0.4)',
};

export default shadow;
